module.exports = __webpack_public_path__ + "static/poster4-44fde13f4cc4e43ba96f8917c098dbfd.png";